// extracted by mini-css-extract-plugin
module.exports = {"container":"S03_Video_container__3hhBj","video":"S03_Video_video__2WXD6"};